const house_sec1_part4Object = payload => {
  return {
    type: "housesec1part4",
    payload
  };
};

export default house_sec1_part4Object;
